import { FunctionComponent, useEffect, useState } from "react";
import { format } from "date-fns";
import Modal from "../../modal/modal";
import { AttendancesComments, PreAttendance } from "../../../types";
import EditAttendanceStatus from "../edit-attendace-status/edit-attendance-status";
import AttendanceData from "../../attendance-status/attendance-status";
import CheckinData from "../../checkin-data/checkin-data";
import { Box, Text, Flex, Link, Icon } from "@chakra-ui/react";
import History from "../history";
import { HiOutlinePencil } from "react-icons/hi";
import { AttendanceStatusEnum } from "../../../model/AttendanceStatus";
import AddCommentButton from "../comment/add-comment-button";
import CommentForm from "../comment/comment-form";
import { hasListeners, ActionListeners } from "../../../hooks/listerners";

interface AttendanceCheckinModalProps {
  currentAttendance: PreAttendance;
  modalOpened: boolean;
  handleCloseModal: () => void;
  chosenDate: Date;
  history: AttendancesComments[];
  refetch: () => void;
  listeners?: ActionListeners[];
}

const AttendanceCheckinModal: FunctionComponent<AttendanceCheckinModalProps> = ({
  currentAttendance,
  handleCloseModal,
  modalOpened,
  chosenDate,
  history,
  refetch,
  listeners,
}): JSX.Element => {
  const [attendanceFormOpened, changeAttendanceFormOpened] = useState<boolean>(false);
  const [commentFormOpened, changeCommentFormOpened] = useState<boolean>(false);
  const [currentPreAttendanceState, setCurrentPreAttendanceState] = useState<PreAttendance | null>(null);

  hasListeners(
    { propsToWatch: { modalOpened }, performArgument: { attendance: currentPreAttendanceState } },
    listeners
  );

  const closeCommentForm = () => {
    changeCommentFormOpened(false);
  };

  const closeAttendanceForm = () => {
    changeAttendanceFormOpened(false);
  };

  const openCommentForm = () => {
    changeCommentFormOpened(true);
    changeAttendanceFormOpened(false);
  };

  const openEditAttendanceForm = () => {
    changeAttendanceFormOpened(true);
    changeCommentFormOpened(false);
  };

  const onClose = () => {
    changeAttendanceFormOpened(false);
    changeCommentFormOpened(false);
    handleCloseModal();
  };

  const attendanceEditSuccess = (attendance: PreAttendance) => {
    changeAttendanceFormOpened(false);
    setCurrentPreAttendanceState(attendance);
    refetch();
  };

  const commentCreateSuccess = () => {
    changeCommentFormOpened(false);
    refetch();
  };

  useEffect(() => {
    setCurrentPreAttendanceState(currentAttendance);
  }, [currentAttendance]);

  const showHistory = !attendanceFormOpened && !commentFormOpened;

  if (currentPreAttendanceState) {
    const showAttendanceEditButton =
      currentPreAttendanceState.status.name !== AttendanceStatusEnum.AWAITING && showHistory;

    return (
      <Modal show={modalOpened} width={450} onClose={onClose}>
        <Text textAlign="center" fontSize="1.5rem" fontWeight="bold" mb="1.5rem">
          Registro De Atividade
        </Text>
        <Box w="17rem">
          <Text textAlign="center" fontSize="1rem" fontWeight="bold" mb="1rem">
            Aluno: <span style={{ fontWeight: "normal" }}>{currentPreAttendanceState.student.name}</span>
          </Text>
          <Flex m="0 auto" alignItems="flex-start" justifyContent="space-between">
            <Flex flexDirection="column" alignItems="center">
              <Text fontSize="1rem" fontWeight="bold" mb="1rem">
                Data: {format(chosenDate, "dd/MM/yyyy")}
              </Text>
              <CheckinData
                checkins_data={currentPreAttendanceState.checkins.map(data => ({
                  status: data.status,
                  checkedAt: data.checkedAt,
                  period: data.period,
                }))}
              />
            </Flex>
            <Flex flexDirection="column" alignItems="center">
              <Text fontSize="1rem" fontWeight="bold" mb="1rem">
                Status
              </Text>
              <AttendanceData status={currentPreAttendanceState.status} />
              {showAttendanceEditButton && (
                <Link
                  display="flex"
                  alignItems="center"
                  m="0.25rem auto"
                  onClick={openEditAttendanceForm}
                >
                  <Text fontSize="0.75rem" marginRight="0.25rem">
                    Editar
                  </Text>
                  <Icon as={HiOutlinePencil} fontSize="0.75rem" />
                </Link>
              )}
            </Flex>
          </Flex>
        </Box>
        {showHistory && (
          <>
            <AddCommentButton onClick={openCommentForm} />
            <History history={history} />
          </>
        )}
        {commentFormOpened && (
          <CommentForm
            studentId={currentAttendance.student.id as string}
            date={format(chosenDate, "yyyy-MM-dd")}
            onSubmit={commentCreateSuccess}
            onCancel={closeCommentForm}
          />
        )}
        {attendanceFormOpened && (
          <EditAttendanceStatus
            attendance={currentPreAttendanceState}
            onSubmitPreAttendance={attendanceEditSuccess}
            onCancel={closeAttendanceForm}
            attendedAt={format(chosenDate, "dd/MM/yyyy")}
          />
        )}
      </Modal>
    );
  }
  return <></>;
};

export default AttendanceCheckinModal;
